import SourceOSM from "ol/source/OSM";
function osm() {
    return new SourceOSM();
}
export default osm;
